var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14c0-7.732-6.268-14-14-14S0 6.268 0 14s6.268 14 14 14 14-6.268 14-14ZM8.673 8.673a.934.934 0 0 1 1.232-.077l.088.077 3.96 3.96 3.96-3.96a.933.933 0 0 1 1.397 1.232l-.077.088-3.96 3.96 3.96 3.96A.933.933 0 0 1 18 19.31l-.088-.077-3.96-3.96-3.96 3.96A.933.933 0 0 1 8.596 18l.077-.088 3.96-3.96-3.96-3.96a.933.933 0 0 1 0-1.32Z"
  })));
};

export default SvgClose;